import { lazy, type ComponentType } from 'react';

import type { ReoSliderLazyWithConfigProps } from './RecommendationsSliderLazy';

export default lazy(
  () => import('./RecommendationsSliderLazy')
) as ComponentType<ReoSliderLazyWithConfigProps>;
